export default __webpack_public_path__ + "static/media/img4.43e0962e.jpg";